export default {
  autoCompleteSSuggestionPadding: 32,
  fromFlightIdDateFormat: 'YYYYMMDD',
  dateIncludingDay: 'ddd DD MMM YYYY',
  stdDateFormat: 'YYYY-MM-DDTHH:mm:ss',
  backEndDateFormat: 'YYYY-MM-DD',
  frontEndDateFormat: 'DD-MM-YYYY',
  frontEndDatePlaceholder: 'dd-mm-yyyy',
  frontEndDatePattern: '[0-9]{2}-[0-9]{2}-[0-9]{4}',
  seatTrade: 'seattrade',
  newBookingInfantMargin: 2,
  checkedIn: 'CheckedIn',
  beforeCheckIn: 'BeforeCheckIn',
  csvFileISOType: 'ISO-8859-1',
  defaultTravelClass: 'Economy',
  economyTravelClass: 'Economy',
  smartTravelClass: 'Smart',
  luggagePrefix: '5B',
  SSRIds: ['ssrId', 'SsrId', 'PassengerId'],
  fieldErrorCodesThatShouldBeShownGlobally: ['Adults', 'flightId'],
}
